export default __webpack_public_path__ + "static/media/icon_trash.d3336c32.svg";